var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clipboard-text",class:{'styled' : !_vm.suppressStyles},attrs:{"id":_vm.id,"data-clipboard-target":("#" + _vm.id)}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }